import React from "react";
import "./Organizers.css"; // Importa o CSS que criamos
// Certifique-se de que a imagem existe em public/assets/img/ ou importe-a
// Exemplo se estiver importando: import logoImg from '../assets/img/onurbpass_mark.png';

const Organizers = () => {
  return (
    <div className="organizers-page">
      {/* --- HERO SECTION --- */}
      <section className="page-hero">
        <div className="container">
          <h1>PARA ORGANIZADORES</h1>
          <div className="sub">
            Venda ingressos com tecnologia, controle e dinheiro na mão.
          </div>
          <div
            style={{
              display: "flex",
              gap: "12px",
              flexWrap: "wrap",
              marginTop: "18px",
            }}
          >
            <a className="btn btn-primary" href="/organizadores/login">
              Quero vender meu evento na ONURB
            </a>
            <a className="btn" href="/eventos">
              Ver vitrine de eventos
            </a>
          </div>
          <div
            className="small"
            style={{ marginTop: "14px", color: "rgba(255,255,255,0.6)" }}
          >
            ONURB Pass (vendas) + ONURB Finance (repasses e antecipação) —
            operação simples, transparente e segura.
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {/* 3 CARDS TOP */}
          <div
            className="grid"
            style={{ gridTemplateColumns: "repeat(3,1fr)", gap: "14px" }}
          >
            <div
              className="card"
              style={{ padding: "16px", borderRadius: "18px" }}
            >
              <div
                className="title"
                style={{ fontSize: "16px", fontWeight: "bold" }}
              >
                Checkout moderno
              </div>
              <div className="small" style={{ marginTop: "10px" }}>
                Pix, débito e crédito. Até 3x sem juros e parcelamento maior com
                juros exibidos na hora.
              </div>
            </div>
            <div
              className="card"
              style={{ padding: "16px", borderRadius: "18px" }}
            >
              <div
                className="title"
                style={{ fontSize: "16px", fontWeight: "bold" }}
              >
                Transparência total
              </div>
              <div className="small" style={{ marginTop: "10px" }}>
                Ingresso e taxa sempre separados no checkout. Menos dúvidas,
                mais conversão.
              </div>
            </div>
            <div
              className="card"
              style={{ padding: "16px", borderRadius: "18px" }}
            >
              <div
                className="title"
                style={{ fontSize: "16px", fontWeight: "bold" }}
              >
                ONURB Finance
              </div>
              <div className="small" style={{ marginTop: "10px" }}>
                Repasses organizados e opção de antecipação com critérios de
                segurança.
              </div>
            </div>
          </div>

          <div className="hr" style={{ margin: "22px 0" }}></div>

          {/* PAIN POINTS */}
          <div
            className="card"
            style={{ padding: "18px", borderRadius: "20px" }}
          >
            <div className="title" style={{ fontSize: "18px" }}>
              Você já deve ter passado por isso
            </div>
            <ul className="list">
              <li>Plataformas que travam vendas em horários críticos.</li>
              <li>Taxas confusas que viram reclamação no checkout.</li>
              <li>Dinheiro preso até depois do evento.</li>
              <li>Falta de clareza sobre repasses e antecipações.</li>
              <li>Suporte que some quando você mais precisa.</li>
            </ul>
            <div className="note" style={{ marginTop: "14px" }}>
              <strong>A ONURB nasce para resolver exatamente isso. </strong>
              Você foca no evento. A ONURB cuida da tecnologia e do dinheiro.
            </div>
          </div>

          {/* SPLIT PASS / FINANCE */}
          <div
            className="grid"
            style={{
              gridTemplateColumns: "1fr 1fr",
              gap: "14px",
              marginTop: "14px",
            }}
          >
            <div
              className="card"
              style={{ padding: "18px", borderRadius: "20px" }}
            >
              <div className="title" style={{ fontSize: "18px" }}>
                ONURB PASS
              </div>
              <div
                className="small"
                style={{ marginTop: "10px", opacity: 0.8 }}
              >
                Plataforma de venda de ingressos
              </div>
              <ul className="list">
                <li>Página profissional do seu evento</li>
                <li>Lotes, quantidades e vitrine com imagens</li>
                <li>Checkout rápido e transparente</li>
                <li>Pix, débito e crédito</li>
                <li>Parcelamento claro para o comprador</li>
              </ul>
            </div>

            <div
              className="card"
              style={{ padding: "18px", borderRadius: "20px" }}
            >
              <div className="title" style={{ fontSize: "18px" }}>
                ONURB FINANCE
              </div>
              <div
                className="small"
                style={{ marginTop: "10px", opacity: 0.8 }}
              >
                Gestão financeira do evento
              </div>
              <ul className="list">
                <li>Repasses organizados</li>
                <li>Opção de antecipação de recebíveis</li>
                <li>Transparência de taxas</li>
                <li>Controle de caixa e operação segura</li>
                <li>Estrutura pronta para escalar</li>
              </ul>
            </div>
          </div>

          {/* COMO FUNCIONA */}
          <div
            className="card"
            style={{ padding: "18px", borderRadius: "20px", marginTop: "14px" }}
          >
            <div className="title" style={{ fontSize: "18px" }}>
              Como funciona
            </div>
            <div
              className="grid"
              style={{
                gridTemplateColumns: "repeat(4,1fr)",
                gap: "12px",
                marginTop: "12px",
              }}
            >
              {[
                {
                  step: "1) Cadastro",
                  text: "Você envia informações do evento (data, local, valores e regras).",
                },
                {
                  step: "2) Página pronta",
                  text: "Publicamos a página do evento com lotes e checkout profissional.",
                },
                {
                  step: "3) Vendas ao vivo",
                  text: "Acompanhe performance e demanda por lote/área.",
                },
                {
                  step: "4) Repasse",
                  text: "Receba conforme combinado ou solicite antecipação via ONURB Finance.",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="card"
                  style={{ padding: "14px", borderRadius: "16px" }}
                >
                  <div style={{ fontWeight: 900 }}>{item.step}</div>
                  <div className="small" style={{ marginTop: "8px" }}>
                    {item.text}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* COMPARISON / AUDIENCE */}
          <div
            className="grid"
            style={{
              gridTemplateColumns: "1.2fr .8fr",
              gap: "14px",
              marginTop: "14px",
            }}
          >
            <div
              className="card"
              style={{ padding: "18px", borderRadius: "20px" }}
            >
              <div className="title" style={{ fontSize: "18px" }}>
                Por que escolher a ONURB
              </div>
              <ul className="list">
                <li>
                  <b>Até 3x sem juros</b> para aumentar conversão sem confusão.
                </li>
                <li>
                  <b>Taxa visível</b> e separada do ingresso (transparência
                  real).
                </li>
                <li>
                  <b>Antecipação sob controle</b> (sem promessas irreais).
                </li>
                <li>
                  <b>Tecnologia moderna</b> (rápido, estável, responsivo).
                </li>
                <li>
                  <b>Suporte humano</b> quando importa.
                </li>
              </ul>
            </div>

            <div
              className="card"
              style={{ padding: "18px", borderRadius: "20px" }}
            >
              <div className="title" style={{ fontSize: "18px" }}>
                Para quem é
              </div>
              <ul className="list">
                <li>Festas e eventos noturnos</li>
                <li>Shows e festivais</li>
                <li>Congressos e palestras</li>
                <li>Eventos corporativos</li>
                <li>Produtores e agências</li>
              </ul>
              <div className="note" style={{ marginTop: "14px" }}>
                Se você vende ingressos, a ONURB é pra você.
              </div>
            </div>
          </div>

          {/* CADASTRO FORM */}
          <div
            className="card"
            id="cadastro"
            style={{ padding: "18px", borderRadius: "20px", marginTop: "14px" }}
          >
            <div className="title" style={{ fontSize: "18px" }}>
              Quero vender meu evento na ONURB
            </div>
            <div className="small" style={{ marginTop: "10px" }}>
              Preencha os dados abaixo (modelo). No lançamento, isso vira um
              formulário integrado.
            </div>

            <div
              className="grid"
              style={{
                gridTemplateColumns: "1fr 1fr",
                gap: "12px",
                marginTop: "12px",
              }}
            >
              <input
                className="btn select-light"
                style={{ textAlign: "left" }}
                placeholder="Nome do evento"
              />
              <input
                className="btn select-light"
                style={{ textAlign: "left" }}
                placeholder="Cidade / Estado"
              />
              <input
                className="btn select-light"
                style={{ textAlign: "left" }}
                placeholder="Data do evento"
              />
              <input
                className="btn select-light"
                style={{ textAlign: "left" }}
                placeholder="Telefone / WhatsApp"
              />
            </div>

            <textarea
              className="btn select-light"
              style={{
                width: "100%",
                minHeight: "110px",
                textAlign: "left",
                marginTop: "12px",
                padding: "12px",
                fontWeight: 700,
              }}
              placeholder="Conte um pouco sobre o evento (público, lotes, preços, estrutura)…"
            ></textarea>

            <div
              style={{
                display: "flex",
                gap: "12px",
                flexWrap: "wrap",
                marginTop: "12px",
              }}
            >
              <a className="btn btn-primary" href="mailto:contato@onurb.com">
                Enviar (e-mail modelo)
              </a>
              <a
                className="btn"
                href="https://wa.me/"
                target="_blank"
                rel="noreferrer"
              >
                Falar no WhatsApp
              </a>
            </div>

            <div
              className="small"
              style={{ marginTop: "10px", color: "rgba(255,255,255,0.72)" }}
            >
              * Ajuste estes contatos para seus canais reais quando for lançar.
            </div>
          </div>

          {/* FAQ */}
          <div
            className="card"
            style={{ padding: "18px", borderRadius: "20px", marginTop: "14px" }}
          >
            <div className="title" style={{ fontSize: "18px" }}>
              FAQ
            </div>
            <div className="faq">
              {[
                {
                  q: "A ONURB compra o evento?",
                  a: "Não. A ONURB é a plataforma de venda e a estrutura financeira para repasses/antecipação.",
                },
                {
                  q: "Tem antecipação?",
                  a: "Sim, sob análise e critérios de segurança (perfil do evento, histórico, volume e risco).",
                },
                {
                  q: "O público vê taxas e juros?",
                  a: "Sim. Taxa ONURB separada do ingresso e juros exibidos no parcelamento acima de 3x.",
                },
              ].map((faq, i) => (
                <details
                  key={i}
                  className="card"
                  style={{
                    padding: "12px",
                    borderRadius: "16px",
                    marginBottom: "8px",
                  }}
                >
                  <summary style={{ cursor: "pointer", fontWeight: 900 }}>
                    {faq.q}
                  </summary>
                  <div className="small" style={{ marginTop: "10px" }}>
                    {faq.a}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* --- FOOTER --- */}
      <footer className="footer footer-enterprise">
        <div className="container">
          <div className="footer-grid">
            <div>
              <div className="footer-brand">
                <img
                  className="brand-mark"
                  src="/assets/img/onurbpass_mark.png"
                  alt="ONURB Pass"
                />
                <div className="brand-text">ONURB PASS</div>
              </div>
              <div className="small" style={{ opacity: 0.7 }}>
                Plataforma de venda de ingressos com checkout transparente e
                experiência de compra profissional.
              </div>
              <div style={{ marginTop: "12px" }}>
                <span className="badge">PIX</span>
                <span className="badge">Crédito</span>
                <span className="badge">Débito</span>
              </div>
            </div>

            <div>
              <div className="title" style={{ fontSize: "14px" }}>
                Organizadores
              </div>
              <a className="footer-link" href="/organizadores">
                Para organizadores
              </a>
              <a className="footer-link" href="/como-funciona">
                Como funciona
              </a>
              <a className="footer-link" href="/taxas">
                Taxas
              </a>
            </div>

            <div>
              <div className="title" style={{ fontSize: "14px" }}>
                Legal
              </div>
              <a
                className="footer-link"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  alert("Termos de Uso");
                }}
              >
                Termos de uso
              </a>
              <a
                className="footer-link"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  alert("Política");
                }}
              >
                Política de privacidade
              </a>
              <a className="footer-link" href="/login">
                Meus ingressos
              </a>
            </div>
          </div>

          <div className="hr" style={{ opacity: 0.3, margin: "20px 0" }}></div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "10px",
              fontSize: "12px",
              opacity: 0.6,
            }}
          >
            <div>© 2026 ONURB Pass • Todos os direitos reservados</div>
            <div style={{ display: "flex", gap: "10px" }}>
              <a href="/eventos">Eventos</a>
              <span>•</span>
              <a href="/organizadores">Organizadores</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Organizers;
